import "./app.css";
import React, { useState } from "react";
import "solenolyrics";

function App() {
  var [song, setSong] = useState("");
  var [lyrics, setLyrics] = useState("Search for a song..");

  // function to fetch Lyrics
  async function fetchLyrics() {
    setLyrics("Loading...");
    const solenolyrics = require("solenolyrics");

    var lyric = await solenolyrics.requestLyricsFor(song);
    setLyrics(lyric);
  }

  return (
    <div className="app">
      <div
        className="search shadow-xl bg-white p-2 m-4 rounded flex justify-between"
        data-aos="slide-down"
        data-aos-delay="100"
      >
        <input
          type="text"
          onChange={(e) => setSong(e.target.value)}
          className="p-1 bg-black-100 rounded shadow-xl m-1"
        />
        <button
          onClick={fetchLyrics}
          className="p-1 bg-blue-600 text-white rounded shadow-xl ml-2 hover:bg-blue-400 text-xl"
        >
          Search
        </button>
      </div>
      <div
        className="lyrics p-3 m-4 bg-white shadow-xl rounded w-96 text-center"
        data-aos="slide-right"
        data-aos-delay="100"
      >
        <p>{lyrics}</p>
      </div>
    </div>
  );
}
export default App;
